// custom js bbb code

// sticky header
$(document).ready(function(){
        //add for sticky menu
        //offset() measures how far down the sticky element is from the top of the window
  var stickyTop = $(".header-fixed--true").offset().top;
        //whenever the user scrolls, measure how far we have scrolled
  $(window).scroll(function() {
    var windowTop = $(window).scrollTop();
          //check to see if we have scrolled past the original location of the sticky element
    if (windowTop > stickyTop) {
            //if so, change the sticky element to fised positioning
      $(".desktop-nav").addClass("stuck");
      $("body").addClass("sticky-main");
            // $(".top_bar").addClass("no-stuck");
    } else {
      $(".desktop-nav").removeClass("stuck");
      $("body").removeClass("sticky-main");
            // $(".top_bar").removeClass("no-stuck");
    }
  });
});
// sticky header

// header dynamic bar annoucement
$(document).ready(function(){

  $('.promo_banner-close').click(function() {
    $(this).parent().hide();
    $('.mobile_nav-fixed--true #pagecontent').css('padding-bottom','20px');
  });

  $(".regular").slick({ 
    autoplay: true,
    autoplaySpeed: 3000,
    vertical: false,
    dots:false,
    infinite:!0,
    slidesToShow:1,
    slidesToScroll:1,
    responsive:[
    {
      breakpoint:1024,
      settings:{
        slidesToShow:1,
        slidesToScroll:1,
        infinite:!0,
        dots:false
      }
    },
    {
      breakpoint:640,
      settings:{
        slidesToShow:1,
        slidesToScroll:1
      }
    },
    {
      breakpoint:480,
      settings:{
        slidesToShow:1,
        slidesToScroll:1
      }
    }
    ]
  })

// PDP logo
  $(".logobar-slick").slick({ 
    autoplay: true,
    autoplaySpeed: 3000,
    vertical: false,
    dots:false,
    prevArrow: false,
    nextArrow: false,
    infinite:!0,
    slidesToShow:9,
    slidesToScroll:1,
    responsive:[
    {
      breakpoint:1024,
      settings:{
        slidesToShow:5,
        slidesToScroll:1,
        infinite:!0,
        dots:false
      }
    },
    {
      breakpoint:640,
      settings:{
        slidesToShow:4,
        slidesToScroll:1
      }
    },
    {
      breakpoint:480,
      settings:{
        slidesToShow:3,
        slidesToScroll:1
      }
    }
    ]
  })
// PDP logo

});

// home page jj banner - begin
// $(document).ready(function(){
//   if ($(window).width() >= 992) {

//   var windowWidth = window.innerWidth - 6;
//   $(".home_page_resize").attr("style", "width:" + windowWidth + "px");

//   // var home_pageClip = $('.home_page_slider_left .home_page_left_resize').height() -22;
//   // $('.clipPath').attr('style' , 'top:'+home_pageClip+'px');

//   $(window).resize(function () {
//   var windowWidth = window.innerWidth - 6;
//   $(".home_page_resize").attr("style", "width:" + windowWidth + "px");

//   //   var home_pageClip = $('.home_page_slider_left .home_page_left_resize').height() -22;
//   //   $('.clipPath').attr('style' , 'top:'+home_pageClip+'px');

//   });

//   $(".jj-banner-animation").attr("style", "opacity:1");
//   }

//   $(".right_arrow ,.home_page_read_top").on("click", function () {
//     $("body").toggleClass("home_page_left_full");
//   });
//   $(".left_arrow ,.home_page_read_bottom").on("click", function () {
//     $("body").toggleClass("home_page_right_full");
//   });

// });
// home page jj banner - end


// country localization selector - begin
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);
// country localization selector - end


// language selector - begin

var $disclosure = $('[data-disclosure]');
var $toggle = $('[data-disclosure-toggle]');
var $disclosureWrap = $('.disclosure__list-wrap');

function closeDisclosures(ignoreTarget, currentTarget) {
  if(ignoreTarget === true) {
    $toggle.not(currentTarget).removeClass('is-clicked');
    $toggle.not(currentTarget).attr('aria-expanded', 'false');
  } else {
    $toggle.removeClass('is-clicked');
    $toggle.attr('aria-expanded', 'false');
  }

  $disclosureWrap.removeClass('disclosure--left');
}

//Check if current opened menu is offscreen
function checkOffScreen($openedToggle) {
  if($openedToggle.siblings('.disclosure__list-wrap').is(':off-right')) {
    $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
  }
}

 $disclosure.on('mouseleave', function(e) {
      closeDisclosures();
    });

 // //On click/focus event for toggling options
$('.locale--selector').on('mouseenter focus', function(e) {
      //Close all other menus
  closeDisclosures(true, this);

  var $target = $(e.currentTarget);
  $target.attr('aria-expanded', 'true').addClass('is-clicked');
  checkOffScreen($target);

});

$('.disclosure__button').on('focusout', function(e) {
      //Close all other menus
  if(!$(e.relatedTarget).hasClass('disclosure__button') || $(e.relatedTarget).hasClass('disclosure__toggle')) {
    closeDisclosures();
  }
});

// language selector - end


// custom carousel
if ($(window).width() < 799) {

  $('.custom-carousel').flickity({
    "draggable": true,
    "imagesLoaded": true,
    "contain": true,
    "pageDots": true
  });
// start with 1th slide
  // $('.custom-carousel').flickity( 'select', 1, true, true );
}else{
  $('.custom-carousel').flickity({
    "draggable": true,
    "imagesLoaded": true,
    "contain": true,
    "pageDots": false
  });
// start with 1th slide
  // $('.custom-carousel').flickity( 'select', 1, true, true );

}